module.exports = __webpack_public_path__ + "img/status-wallet.eac1756a.png";